// extracted by mini-css-extract-plugin
module.exports = {"SubTopicData":"SubTopicData_SubTopicData__VGCrd","SubTopicDataItems":"SubTopicData_SubTopicDataItems__k_i8-","Loading":"SubTopicData_Loading__2kosj"};